export default "__VITE_ASSET__BVNSZtwi__"